import { ChangeDetectorRef, Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AbilitiesSelectors } from '@recruitee/abilities-data';
import { Ability } from '@recruitee/abilities-types';
import { SubscriptionService } from '@recruitee/company';
import { I18nService, TranslatePipe } from '@recruitee/i18n';

import { SurveyBannerComponent } from '../../ui/survey-banner/survey-banner.component';

@Component({
  selector: 'rt-hr-banner',
  templateUrl: './hr-banner.component.html',
  standalone: true,
  imports: [SurveyBannerComponent, TranslatePipe],
})
export class HrBannerComponent {
  public hrBannerVisible: boolean;
  private supportedLocale = ['en', 'de', 'fr', 'nl'];
  constructor(
    private store: Store,
    private subscriptionService: SubscriptionService,
    private i18nService: I18nService,
    private cdRef: ChangeDetectorRef,
    private destroyRef: DestroyRef,
  ) {}

  public ngOnInit(): void {
    this.resolveBannerVisibility();
  }

  private resolveBannerVisibility(): void {
    combineLatest([
      this.store.select(AbilitiesSelectors.hasOne(Ability.ViewAllJobs)),
      of(!this.subscriptionService.isTrial()),
      of(this.supportedLocale.includes(this.i18nService.locale)),
    ])
      .pipe(
        map(requirements => requirements.every((requirement: boolean) => requirement)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(hasAccess => {
        this.hrBannerVisible = hasAccess;
        this.cdRef.detectChanges();
      });
  }
}
